<!-- @if (!subscriptionOverview.subscriptionId()) {
<mat-spinner class="spinner" diameter="40" color="primary"></mat-spinner>
} -->
<div class="content">
    <div class="side-menu">
        <div>
            <button class="addbutton" (click)="newWorkflow()">
                <mat-icon>add</mat-icon>
                <span>New contract</span>
            </button>
        </div>

        @for (workflow of subscriptionOverview.workflowOverviewFiltered(); track workflow) {
            @if (workflow.contentCollectionType === "prompt_testing") {
                <div class="workflow-option" (click)="openWorkflow(workflow.uid)">
                    <a>
                        <span> {{workflow.name}}</span>
                        <div>
                            <mat-icon (click)="deleteWorkflow(workflow.uid)">delete</mat-icon>
                        </div>
                    </a>
                </div>
            }
        }
    </div>

    <div class="workflow-content">
        @if (!selectedWorkflowId) {
        <div id="workflow-area">
            <div id="workflows">
                <div class="workflow-placeholder">
                    <img [src]="dora_logo" alt="Logo" />
                    <p class="mt-3">
                        Welcome to
                        <b>DORA</b>
                    </p>
                    <p>Let's start by uploading your contract</p>
                </div>
            </div>
        </div>
        }

        @if (selectedWorkflowId) {
            <prompting-view [workflowId]="selectedWorkflowId"></prompting-view>
        }
    </div>
</div>